import type { Translations } from "../types";

const zh: Translations = {
  "meta.title": "各国点击地图",
  "meta.description":
    "互动世界地图：各国免费点击数，另可通过 Stripe、PayPal 和 Buy Me a Coffee 提供付费支持。",

  "app.title": "各国点击地图",

  "map.intro":
    "点击地图上的国家即可为其投一次免费票，或为其提供资金支持——两者都会计入下方的综合排行榜。该地图仅反映本应用内的支持情况，并不代表该国实际财富或 GDP。",
  "map.verifying": "验证中……",
  "map.confirmNotRobot": "在添加免费点击之前，请先快速确认您不是机器人：",
  "map.tryAgain": "重试",
  "map.registeringClick": "正在记录点击……",
  "map.selectedCountry": "已选国家：{name}。",
  "map.selectFirstFeedback": "已选择国家。要添加免费点击，请先在下方确认您不是机器人。",
  "map.verificationExpired": "验证已过期——请重新确认您不是机器人。",
  "map.slowDown": "慢一点——请稍候片刻再进行下一次点击。",
  "map.clickFailed": "点击记录失败，请重试。",
  "map.clickErrorGeneric": "记录点击时出错。",
  "map.leaderboardHeading": "国家排行榜",
  "map.emptySelection": "在地图上选择一个国家以为其点击或提供支持。",
  "map.loadingData": "正在加载数据……",

  "worldmap.loadError": "无法加载地图。",
  "worldmap.resetZoom": "重置缩放",
  "worldmap.resetButton": "⤾ 重置",
  "worldmap.loadingMap": "正在加载地图……",
  "worldmap.unknownCountry": "未知",
  "worldmap.ariaClicks": "{name}：{clicks} 次点击",
  "worldmap.tooltipClicks": "{clicks} 次点击",

  "legend.fewer": "点击较少",
  "legend.more": "点击较多",

  "list.empty": "暂无点击，快来抢占第一！",
  "list.ariaLabel": "按点击数排列的国家排行榜",

  "human.siteKeyMissing": "未设置 VITE_TURNSTILE_SITE_KEY——配置方法请参阅 README。",
  "human.verificationFailedGeneric": "验证失败。",
  "human.networkError":
    "无法连接验证服务（网络错误）——请检查 VITE_SUPABASE_URL、verify-human 是否已部署，以及 ALLOWED_ORIGIN 设置；详见 README/NAVODILA。",
  "human.verificationFailedRetry": "验证失败，请重试。",

  "provider.stripe": "💳 银行卡（Stripe）",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "已选国家",
  "panel.currentlyRanked": "当前排名 #{rank}",
  "panel.shareCopied": "已复制 ✓",
  "panel.shareShared": "已分享 ✓",
  "panel.shareButton": "🔗 分享",

  "panel.tableClicks": "点击数",
  "panel.tableFree": "免费",
  "panel.tablePaid": "付费",
  "panel.rowAllTime": "总计",
  "panel.rowThisYear": "今年",
  "panel.rowThisWeek": "本周",
  "panel.rowToday": "今天",

  "panel.totalCombined": "合计总数：",
  "panel.totalSupport": "支持总额：",

  "panel.paymentMethod": "支付方式",
  "panel.noPaymentMethod": "目前没有可用的支付方式。",
  "panel.supportAmount": "支持金额（欧元）",
  "panel.amountRange": "金额应介于 {min} 到 {max} 之间。",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "预计付费点击数：",
  "panel.ratioInfo":
    "比例：{a} = {b} 次点击（例如 {c} = {d} 次点击）。这仅是支付前的估算——最终点击数始终由服务器根据实际确认的付款计算得出。",
  "panel.preparing": "准备中……",
  "panel.continueWith": "使用 {provider} 继续",
  "panel.choosePaymentMethod": "选择支付方式",
  "panel.bmcUsernameMissing": "未设置 VITE_BMC_USERNAME——配置方法请参阅 README。",
  "panel.paypalClientIdMissing": "未设置 VITE_PAYPAL_CLIENT_ID——配置方法请参阅 README。",

  "panel.paypalAmountInfo": "金额：{amount}（预计 {clicks} 次点击）。请使用下方的 PayPal 按钮完成支付。",
  "panel.back": "← 返回",

  "panel.bmcWarningTitle": "⚠️ 前往 BuyMeCoffee 之前：",
  "panel.bmcWarningBody":
    "请在结账时将下方代码粘贴到留言/备注栏中——这是我们判断您支持哪个国家的唯一方式。没有该代码，我们将无法把付款归属到任何国家。",
  "panel.copy": "复制",
  "panel.copied": "已复制 ✓",
  "panel.suggestedAmount": "建议金额：",
  "panel.bmcAmountNote":
    "（预计 {clicks} 次点击）。很遗憾，BuyMeCoffee 不支持通过链接传递金额——请在其网站上自行输入或选择金额。实际点击数始终根据您在 BuyMeCoffee 上实际支付的金额计算，而非此估算值。",
  "panel.openBmc": "打开 BuyMeCoffee 并继续 →",
  "panel.waitingProvider": "正在等待支付提供商确认付款……",
  "panel.waitingConfirmation": "正在等待付款确认……",
  "panel.timedOut":
    "检查超时。如果您已完成付款，地图将在服务器收到确认后更新——这有时需要多等一会儿。",
  "panel.checkAgain": "再次检查",

  "panel.cancelled": "付款已取消或未成功完成。地图未发生变化。",
  "panel.tryAgain": "重试",

  "panel.confirmed": "✅ 支持已确认！",
  "panel.confirmedBody": "{country} 获得了 {clicks} 次付费点击，金额为 {amount}。",

  "panel.errorPreparingSupport": "准备您的支持时出错。",
  "panel.errorPreparingPayment": "准备付款时出错。",
  "panel.errorConfirmingPayment": "确认付款时出错。",
  "panel.errorPayingPaypal": "使用 PayPal 付款时出错。",

  "share.unranked": "{flag}{country} 需要您在世界地图上的支持！\n帮助它登上排行榜 👇",
  "share.rank1": "{flag}{country} 目前排名第一！\n帮助我们保持第一 👇",
  "share.rankN": "{flag}{country} 目前排名 #{rank}！\n帮助我们冲上第一 👇",

  "language.switcherLabel": "语言",
};

export default zh;
